<template>
    <div class="@container">
        <div :class="gridClasses">
            <div :class="gridKeyClasses">Phone:</div>
            <div :class="gridValueClasses">
                {{ formatPhoneNumber(contact.phone) || '-' }}
            </div>
            <div :class="gridKeyClasses">First Name:</div>
            <div :class="gridValueClasses">
                {{ contact.first_name || '-' }}
            </div>
            <div :class="gridKeyClasses">Last Name:</div>
            <div :class="gridValueClasses">
                {{ contact.last_name || '-' }}
            </div>
            <div :class="gridKeyClasses">Email:</div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loading && !contact.email" spin></vx-icon-loading>
                <div v-else>
                    {{ contact.email || '-' }}
                </div>
            </div>
            <div :class="gridKeyClasses">Time-zone:</div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loading && !contact.time_zone" spin></vx-icon-loading>
                <div v-else>
                    {{ contact.time_zone || '-' }}
                </div>
            </div>
            <div :class="gridKeyClasses">Entry Channel:</div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loading && !contact.entry_channel" spin></vx-icon-loading>
                <div v-else>
                    {{ contact.entry_channel || '-' }}
                </div>
            </div>
            <div :class="gridKeyClasses">Membership Status:</div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loading && !contact.membership_status" spin></vx-icon-loading>
                <div v-else>
                    {{ contact.membership_status || '-' }}
                </div>
            </div>
            <div :class="gridKeyClasses">Lifecycle Status:</div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loading && !contact.lifecycle_status" spin></vx-icon-loading>
                <div v-else>
                    {{ contact.lifecycle_status || '-' }}
                </div>
            </div>
            <div :class="gridKeyClasses">Added:</div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loading && !contact.created_at" spin></vx-icon-loading>
                <div v-else>
                    {{ contact.created_at ? shortDateTime(contact.created_at) : '-' }}
                </div>
            </div>
            <div :class="gridKeyClasses">Entry Point:</div>
            <div :class="gridValueClasses">
                <vx-icon-loading v-if="loading && !contact.entry_point" spin></vx-icon-loading>
                <div v-else>
                    {{ entryPoint(contact.entry_point) }}
                </div>
            </div>
            <div v-if="!groupId" :class="gridKeyClasses">Sticky Phone Number:</div>
            <div v-if="!groupId" :class="gridValueClasses">
                <vx-icon-loading v-if="loadingStickyPhoneNumber && !stickyPhoneNumber" spin></vx-icon-loading>
                <div v-else>
                    {{ stickyPhoneNumber ? formatPhoneNumber(stickyPhoneNumber.phone_number) : '-' }}
                </div>
            </div>
            <div v-if="props.editableRelationships" class="col-span-full mt-2">
                <vx-button :href="`/contacts/${contact.id}/view`" target="_blank" color="muted-light" block size="md">
                    Go to Contact <font-awesome-icon widthAuto :icon="faSquareArrowUpRight"></font-awesome-icon>
                </vx-button>
            </div>
        </div>

        <contact-view-relationships
            :editable="props.editableRelationships"
            @currentGroupRemoved="emit('currentGroupRemoved')"
        ></contact-view-relationships>
    </div>
</template>

<script setup>
import { faSquareArrowUpRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxIconLoading } from '@voxie/frontend-components';
import { watch } from 'vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';
import ContactViewRelationships from '~/components/contacts/contact/view/ContactViewRelationships.vue';
import { entryPoint, formatPhoneNumber } from '~/components/filters';
import { shortDateTime } from '~/utils/date';

const props = defineProps({
    allowEditContact: {
        type: Boolean,
        default: true,
    },
    editableRelationships: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['currentGroupRemoved']);

const gridClasses = 'grid grid-cols-1 @xs:grid-cols-[132px_1fr] items-center text-slate-800 text-sm mb-6';
const gridKeyClasses = 'break-all text-xs text-slate-500 @xs:pb-2';
const gridValueClasses = 'break-all pb-2';

const {
    loading,
    contact,
    groupId,

    getStickyPhoneNumber,
    loadingStickyPhoneNumber,
    stickyPhoneNumber,

    getGroups,
    getSubscriptions,
    getTags,
    getCustomAttributes,
} = useContactDetails();

watch(
    () => contact.value?.id,
    (contactId) => {
        if (!contactId) {
            return;
        }
        getStickyPhoneNumber();
        getGroups();
        getSubscriptions();
        getTags();
        getCustomAttributes();
    },
    {
        immediate: true,
    }
);
</script>
